<template lang="pug">
  .blocks-editor(:style="editorStyle")
    canvas(ref="canvas", @mousemove="onCanvasMouseMove")
    left-menu(:visible="leftMenuVisible", v-if="containerType && leftMenuVisible")
    building-equipment(:visible="buildingEquipmentVisible", v-if="containerType")
    selected-item-options(:item="selectedItem")
    history-buttons(ref="historyManager", @restore="onRestoreFromHistory", :key="'key'")

    .right-side-buttons(:style="{right: buildingEquipmentVisible || (selectedItem !== null && selectedItem.isSetuped) ? '324px' : '0px'}", v-if="containerType")
      stage-select(ref="stageSelect", v-model="selectedStage", v-if="orderStage === null")
      zoom-control
    result-information(v-if="containerType")
    .info-scale(@click="buildingEquipmentVisible = !buildingEquipmentVisible")
    .tooltip-button.no-select(@click="onShowTooltipClick")
</template>
<script>
import CreateJsBlocksEditor from '@/components/BlocksEditor/CreateJsBlocksEditor';
import LeftMenu from '@/components/BlocksEditor/LeftMenu'
import { eventBus } from '@/main';
import EventBusEvents from '@/common/EventBusEvents';
import HistoryButtons from '@/components/BlocksEditor/HistoryButtons';
import ResultInformation from '@/components/BlocksEditor/ResultInformation';
import Events from '@/components/BlocksEditor/CreateJsBlocksEditor/Events';
import { mapActions, mapGetters } from 'vuex';
import WallItem from '@/components/BlocksEditor/CreateJsBlocksEditor/WallItem';
import KrausSelect from '@/components/_common/ui/KrausSelect';
import ZoomControl from '@/components/BlocksEditor/ZoomControl';
import BuildingEquipment from '@/components/BlocksEditor/BuildingEquipment';
import SelectedItemOptions from '@/components/BlocksEditor/SelectedItemOptions';
import Pillar from '@/components/BlocksEditor/CreateJsBlocksEditor/Pillar';
import StageSelect from '@/components/BlocksEditor/StageSelect';
import BaseEditorElement from '@/components/BlocksEditor/CreateJsBlocksEditor/abstract/BaseEditorElement';

export default {
  name: 'BlocksEditor',
  components: { StageSelect, SelectedItemOptions, BuildingEquipment, ZoomControl, KrausSelect, ResultInformation, HistoryButtons, LeftMenu },
  data() {
    return {
      historyManager: null,
      leftMenuVisible: false,
      selectedItem: null,
      needSelectItem: {
        type: null,
        id: null,
      },
      windowSize: {
        width: 0,
        height: 0,
      },
      selectedStage: null,
      currentStage: 1,
      orderStage: null,
      orderSavedStage: null
    }
  },

  created() {
    eventBus.$on(EventBusEvents.ClearProject, this.onClearProject)
    eventBus.$on(EventBusEvents.EditorMenuClicked, this.onEditorMenuClicked)
    eventBus.$on(EventBusEvents.ZoomIn, this.onZoomIn)
    eventBus.$on(EventBusEvents.ZoomOut, this.onZoomOut)
    eventBus.$on(EventBusEvents.FullScreen, this.onFullScreenClick)
    eventBus.$on(EventBusEvents.PrepareImageForDownload, this.onPrepareImageForDownload)
    eventBus.$on(EventBusEvents.CreateStageImages, this.createStageImages)
    eventBus.$on(EventBusEvents.SelectItemInEditor, this.onSelectItemInEditor)
  },

  mounted() {
    this.historyManager = this.$refs.historyManager
    this.createEditor()
    window.addEventListener('resize', this.onWindowResize)

    if (this.clearProject) {
      this.onClearProject()
    }

    this.updateWindowSize()

    if (this.pdfRequested) {
      //this.createStageImages('for-pdf')
    }
  },

  destroyed() {
    eventBus.$off(EventBusEvents.ZoomIn, this.onZoomIn)
    eventBus.$off(EventBusEvents.ZoomOut, this.onZoomOut)
    eventBus.$off(EventBusEvents.FullScreen, this.onFullScreenClick)
    eventBus.$off(EventBusEvents.ClearProject, this.onClearProject)
    eventBus.$off(EventBusEvents.EditorMenuClicked, this.onEditorMenuClicked)
    eventBus.$off(EventBusEvents.PrepareImageForDownload, this.onPrepareImageForDownload)
    eventBus.$off(EventBusEvents.CreateStageImages, this.createStageImages)
    eventBus.$off(EventBusEvents.SelectItemInEditor, this.onSelectItemInEditor)

    this.blocksEditor.removeEventListener(Events.ELEMENTS_CHANGED, this.onElementsChanged)
    this.blocksEditor.removeEventListener(Events.ELEMENT_SELECTED, this.onElementSelected)
    this.blocksEditor.destroy()
    this.blocksEditor = null
    window.removeEventListener('resize', this.onWindowResize)
  },

  watch: {
    containerType() {
      if (this.containerType) {
        this.onClearProject()
        this.blocksEditor.createDefault(this.containerType)

        // this.blocksEditor.setContainerType(this.containerType)
        // this.blocksEditor.restoreFromJson(JSON.parse('{"connectors":[{"id":1,"x":-496,"y":-203,"walls":[1,4,8,31]},{"id":2,"x":89,"y":-203,"walls":[1,2,16,8]},{"id":3,"x":89,"y":42,"walls":[2,3,17,18,7]},{"id":4,"x":-496,"y":42,"walls":[3,4,7,32,33]},{"id":5,"x":89,"y":-127,"walls":[9,12,16,17,20]},{"id":6,"x":674,"y":-127,"walls":[9,10,13,20]},{"id":7,"x":674,"y":118,"walls":[10,11,13,19]},{"id":8,"x":89,"y":118,"walls":[11,12,18,19]},{"id":9,"x":288,"y":-119,"walls":[21]},{"id":10,"x":288,"y":42,"walls":[21]},{"id":11,"x":-200,"y":-37,"walls":[22]},{"id":12,"x":-200,"y":-199,"walls":[22]},{"id":13,"x":89,"y":-123,"walls":[23]},{"id":14,"x":89,"y":-12,"walls":[23]},{"id":15,"x":-1081,"y":-149,"walls":[24,27,28,30]},{"id":16,"x":-496,"y":-149,"walls":[24,25,30,31,32]},{"id":17,"x":-496,"y":96,"walls":[25,26,29,33]},{"id":18,"x":-1081,"y":96,"walls":[26,27,28,29]}],"boxes":[{"id":1,"x":-496,"y":-203,"width":585,"height":245,"length":585,"connectors":[1,2,3,4],"walls":[1,2,3,4],"boxItems":[],"dictionaryData":{}},{"id":2,"x":89,"y":-127,"width":585,"height":245,"length":585,"connectors":[5,6,7,8],"walls":[9,10,11,12],"boxItems":[],"dictionaryData":{}},{"id":3,"x":-1081,"y":-149,"width":585,"height":245,"length":585,"connectors":[15,16,17,18],"walls":[24,25,26,27],"boxItems":[],"dictionaryData":{}}],"walls":[{"id":1,"boxId":1,"connectors":[1,2],"temp":false,"tempDashed":false,"intersectedWalls":[8],"wallItems":[]},{"id":2,"boxId":1,"connectors":[2,3],"temp":false,"tempDashed":true,"intersectedWalls":[16,17],"wallItems":[]},{"id":3,"boxId":1,"connectors":[3,4],"temp":false,"tempDashed":false,"intersectedWalls":[7],"wallItems":[]},{"id":4,"boxId":1,"connectors":[4,1],"temp":false,"tempDashed":true,"intersectedWalls":[31,32],"wallItems":[]},{"id":9,"boxId":2,"connectors":[5,6],"temp":false,"tempDashed":false,"intersectedWalls":[20],"wallItems":[]},{"id":10,"boxId":2,"connectors":[6,7],"temp":false,"tempDashed":false,"intersectedWalls":[13],"wallItems":[]},{"id":11,"boxId":2,"connectors":[7,8],"temp":false,"tempDashed":false,"intersectedWalls":[19],"wallItems":[]},{"id":12,"boxId":2,"connectors":[8,5],"temp":false,"tempDashed":true,"intersectedWalls":[17,18],"wallItems":[]},{"id":24,"boxId":3,"connectors":[15,16],"temp":false,"tempDashed":false,"intersectedWalls":[30],"wallItems":[]},{"id":25,"boxId":3,"connectors":[16,17],"temp":false,"tempDashed":true,"intersectedWalls":[32,33],"wallItems":[]},{"id":26,"boxId":3,"connectors":[17,18],"temp":false,"tempDashed":false,"intersectedWalls":[29],"wallItems":[]},{"id":27,"boxId":3,"connectors":[18,15],"temp":false,"tempDashed":false,"intersectedWalls":[28],"wallItems":[]}],"tempWalls":[{"id":16,"boxId":null,"connectors":[2,5],"temp":true,"tempDashed":false,"intersectedWalls":[2],"wallItems":[]},{"id":17,"boxId":null,"connectors":[5,3],"temp":true,"tempDashed":true,"intersectedWalls":[2,12],"wallItems":[]},{"id":18,"boxId":null,"connectors":[3,8],"temp":true,"tempDashed":false,"intersectedWalls":[12],"wallItems":[]},{"id":13,"boxId":null,"connectors":[6,7],"temp":true,"tempDashed":false,"intersectedWalls":[10],"wallItems":[]},{"id":31,"boxId":null,"connectors":[1,16],"temp":true,"tempDashed":false,"intersectedWalls":[4],"wallItems":[]},{"id":32,"boxId":null,"connectors":[16,4],"temp":true,"tempDashed":true,"intersectedWalls":[4,25],"wallItems":[]},{"id":33,"boxId":null,"connectors":[4,17],"temp":true,"tempDashed":false,"intersectedWalls":[25],"wallItems":[]},{"id":28,"boxId":null,"connectors":[15,18],"temp":true,"tempDashed":false,"intersectedWalls":[27],"wallItems":[]},{"id":7,"boxId":null,"connectors":[4,3],"temp":true,"tempDashed":false,"intersectedWalls":[3],"wallItems":[1,2]},{"id":29,"boxId":null,"connectors":[18,17],"temp":true,"tempDashed":false,"intersectedWalls":[26],"wallItems":[]},{"id":19,"boxId":null,"connectors":[8,7],"temp":true,"tempDashed":false,"intersectedWalls":[11],"wallItems":[]},{"id":8,"boxId":null,"connectors":[1,2],"temp":true,"tempDashed":false,"intersectedWalls":[1],"wallItems":[]},{"id":20,"boxId":null,"connectors":[5,6],"temp":true,"tempDashed":false,"intersectedWalls":[9],"wallItems":[]},{"id":30,"boxId":null,"connectors":[15,16],"temp":true,"tempDashed":false,"intersectedWalls":[24],"wallItems":[]}],"insideWalls":[{"id":21,"boxId":2,"connectors":[9,10],"temp":true,"tempDashed":false,"intersectedWalls":[],"wallItems":[]},{"id":22,"boxId":1,"connectors":[11,12],"temp":true,"tempDashed":false,"intersectedWalls":[],"wallItems":[3]},{"id":23,"boxId":1,"connectors":[13,14],"temp":true,"tempDashed":false,"intersectedWalls":[],"wallItems":[]}],"boxItems":[],"wallItems":[{"id":1,"boxId":1,"wallId":7,"type":"Window","commonRotation":0,"rotation":0,"pointOnWall":120,"width":75,"height":12,"dictionaryData":{"id":"75h85","type":"window","title":"75х85","section":"Деревянные окна","icon":"/pics/menu-items/box.png","menuIcon":"/img/75h85.86c1eafc.svg","latticeEnabled":false,"rollerShuttersEnabled":false,"lattice":null,"rollerShutters":null,"material":"wood","size":{"width":75,"height":85},"data":{"raw":{"key":"75h85","title":"75х85","price":4500,"cost":1,"width":75,"height":85},"cost":4500}}},{"id":2,"boxId":1,"wallId":7,"type":"Door","commonRotation":0,"rotation":0,"pointOnWall":476,"width":80,"height":14,"dictionaryData":{"id":"dver_orgalit","type":"door","title":"Дверь деревянная, обшита оцинкованным листом","section":"Внешние двери","icon":{"dataURL":"/img/dver_orgalit.6ae55601.svg"},"size":{"key":"80_h_200_sm","title":"80 х 200 см","cost":6500,"width":80,"height":200,"raw":{"key":"80_h_200_sm","title":"80 х 200 см","width":80,"height":200,"price":6500,"cost":1,"raw":{"cost":1,"width":80,"height":200,"key":"80_h_200_sm","price":6500,"title":"80 х 200 см"}}},"menuIcon":"/img/dver_orgalit.6ae55601.svg","sizes":[{"key":"80_h_200_sm","title":"80 х 200 см","width":80,"height":200,"price":6500,"cost":1,"raw":{"cost":1,"width":80,"height":200,"key":"80_h_200_sm","price":6500,"title":"80 х 200 см"}},{"key":"90_h_200_sm","title":"90 х 200 см","width":90,"height":200,"price":7000,"cost":1,"raw":{"cost":1,"width":90,"height":200,"key":"90_h_200_sm","price":7000,"title":"90 х 200 см"}},{"key":"100_h_200_sm","title":"100 х 200 см","width":100,"height":200,"price":8000,"cost":1,"raw":{"cost":1,"width":100,"height":200,"key":"100_h_200_sm","price":8000,"title":"100 х 200 см"}}],"lock1Enabled":true,"lock2Enabled":false,"boltEnabled":false,"color":{"key":"no_color","icon":{"color":null},"title":"Без покраски","cost":0,"raw":{"key":"no_color","title":"Без покраски","hex":null,"cost":0,"price":0,"raw":{"cost":0,"hex":null,"key":"no_color","price":0,"title":"Без покраски"}}},"colors":[{"key":"no_color","title":"Без покраски","hex":null,"cost":0,"price":0,"raw":{"cost":0,"hex":null,"key":"no_color","price":0,"title":"Без покраски"}},{"key":"white","title":"Белый 9003","hex":"#F4F4F4","cost":1,"price":0,"raw":{"cost":1,"hex":"#F4F4F4","key":"white","price":0,"title":"Белый 9003"}},{"key":"blue","title":"Синий 5005","hex":"#1E2460","cost":1,"price":0,"raw":{"cost":1,"hex":"#1E2460","key":"blue","price":0,"title":"Синий 5005"}},{"key":"red","title":"Красный 3001","hex":"#A52019","cost":1,"price":0,"raw":{"cost":1,"hex":"#A52019","key":"red","price":0,"title":"Красный 3001"}},{"key":"green","title":"Зеленый 6005","hex":"#2F4538","cost":1,"price":0,"raw":{"cost":1,"hex":"#2F4538","key":"green","price":0,"title":"Зеленый 6005"}},{"key":"gray","title":"Серый 7004","hex":"#969992","cost":1,"price":0,"raw":{"cost":1,"hex":"#969992","key":"gray","price":0,"title":"Серый 7004"}},{"key":"brown","title":"Коричневый 8017","hex":"#45322E","cost":1,"price":0,"raw":{"cost":1,"hex":"#45322E","key":"brown","price":0,"title":"Коричневый 8017"}},{"key":"color_1014","title":"Слоновая кость 1014","hex":"#DED09F","cost":1,"price":0,"raw":{"cost":1,"hex":"#DED09F","key":"color_1014","price":0,"title":"Слоновая кость 1014"}}],"configuration":null,"configurations":null,"inside":false,"metalFinishingEnabled":false,"metalFinishing":null,"closerEnabled":false,"closer":null,"external":true,"data":{"cost":6500,"raw":{"key":"dver_orgalit","title":"Дверь деревянная, обшита оцинкованным листом","options":[{"key":"razmer","title":"Размер","options":[{"key":"80_h_200_sm","title":"80 х 200 см","width":80,"height":200,"price":6500,"cost":1,"raw":{"cost":1,"width":80,"height":200,"key":"80_h_200_sm","price":6500,"title":"80 х 200 см"}},{"key":"90_h_200_sm","title":"90 х 200 см","width":90,"height":200,"price":7000,"cost":1,"raw":{"cost":1,"width":90,"height":200,"key":"90_h_200_sm","price":7000,"title":"90 х 200 см"}},{"key":"100_h_200_sm","title":"100 х 200 см","width":100,"height":200,"price":8000,"cost":1,"raw":{"cost":1,"width":100,"height":200,"key":"100_h_200_sm","price":8000,"title":"100 х 200 см"}}]},{"key":"cvet_dveri","title":"Цвет двери","catalog":"Colors","options":[{"key":"no_color","title":"Без покраски","hex":null,"cost":0,"price":0,"raw":{"cost":0,"hex":null,"key":"no_color","price":0,"title":"Без покраски"}},{"key":"white","title":"Белый 9003","hex":"#F4F4F4","cost":1,"price":0,"raw":{"cost":1,"hex":"#F4F4F4","key":"white","price":0,"title":"Белый 9003"}},{"key":"blue","title":"Синий 5005","hex":"#1E2460","cost":1,"price":0,"raw":{"cost":1,"hex":"#1E2460","key":"blue","price":0,"title":"Синий 5005"}},{"key":"red","title":"Красный 3001","hex":"#A52019","cost":1,"price":0,"raw":{"cost":1,"hex":"#A52019","key":"red","price":0,"title":"Красный 3001"}},{"key":"green","title":"Зеленый 6005","hex":"#2F4538","cost":1,"price":0,"raw":{"cost":1,"hex":"#2F4538","key":"green","price":0,"title":"Зеленый 6005"}},{"key":"gray","title":"Серый 7004","hex":"#969992","cost":1,"price":0,"raw":{"cost":1,"hex":"#969992","key":"gray","price":0,"title":"Серый 7004"}},{"key":"brown","title":"Коричневый 8017","hex":"#45322E","cost":1,"price":0,"raw":{"cost":1,"hex":"#45322E","key":"brown","price":0,"title":"Коричневый 8017"}},{"key":"color_1014","title":"Слоновая кость 1014","hex":"#DED09F","cost":1,"price":0,"raw":{"cost":1,"hex":"#DED09F","key":"color_1014","price":0,"title":"Слоновая кость 1014"}}]}]},"sizes":[{"key":"80_h_200_sm","title":"80 х 200 см","width":80,"height":200,"price":6500,"cost":1,"raw":{"cost":1,"width":80,"height":200,"key":"80_h_200_sm","price":6500,"title":"80 х 200 см"}},{"key":"90_h_200_sm","title":"90 х 200 см","width":90,"height":200,"price":7000,"cost":1,"raw":{"cost":1,"width":90,"height":200,"key":"90_h_200_sm","price":7000,"title":"90 х 200 см"}},{"key":"100_h_200_sm","title":"100 х 200 см","width":100,"height":200,"price":8000,"cost":1,"raw":{"cost":1,"width":100,"height":200,"key":"100_h_200_sm","price":8000,"title":"100 х 200 см"}}]}}},{"id":3,"boxId":1,"wallId":22,"type":"Window","commonRotation":0,"rotation":0,"pointOnWall":61.75,"width":75,"height":12,"dictionaryData":{"id":"75h85_povorotnoe","type":"window","title":"75х85, поворотное","section":"Пластиковые","icon":{"dataURL":"/img/75h85_povorotnoe.32af45f6.svg"},"menuIcon":"/img/75h85_povorotnoe.32af45f6.svg","latticeEnabled":false,"rollerShuttersEnabled":false,"lattice":null,"rollerShutters":null,"material":"plastic","size":{"width":75,"height":85},"data":{"raw":{"key":"75h85_povorotnoe","title":"75х85, поворотное","price":8000,"cost":1,"width":75,"height":85},"cost":8000}}}],"externalItems":[]}'))

        this.currentStage = 1
        this.setStage(this.currentStage)
        this.setJsonData(this.blocksEditor.getJSON())

        this.historyManager.replaceHistory({
          historyList: [],
          index: 0
        })

        this.$nextTick(() => {
          this.setEditorType('3D')
        })
      }
    },

    carcassStrengthening(val) {
      this.updatePillarsState()
    },

    selectedStage(stageModel) {
      const stage = stageModel.stage

      if (this.currentStage !== stage) {
        this.blocksEditor.getImageData().then(data => {
          this.setStageImage({
            stage: this.currentStage,
            data
          })

          this.currentStage = stage
          this.blocksEditor.restoreFromJson(this.jsonData)

          if (this.needSelectItem.type) {
            this.blocksEditor.selectElementByType(this.needSelectItem)
            this.needSelectItem = {
              type: null,
              id: null
            }
          }

          if (stage > 1) {
            this.blocksEditor.setBackgroundImage(this.stageImages[stage - 1])
          } else {
            this.blocksEditor.setBackgroundImage(null)
          }
        })
      }
    }
  },

  computed: {
    ...mapGetters([
      'stage',
      'jsonData',
      'stageImages',
      'insideWallMaterial',
      'carcassStrengthening',
      'containerType',
      'stagesData',
      'clearProject',
      'projectId',
    ]),

    editorStyle() {
      return {
        height: this.windowSize.height - 80 + 'px'
      }
    },

    buildingEquipmentVisible() {
      return this.selectedItem === null
    },

    stagesCount() {
      let maxStage = 1

      for (let key in this.stagesData) {
        if (maxStage < key && this.stagesData[key]) maxStage = key
      }

      return maxStage
    }
  },

  methods: {
    ...mapActions([
      'setJsonData',
      'setStageJsonData',
      'setStage',
      'setStageImage',
      'setOrderingStageImage',
      'cleanProject',
      'setClearProject',
      'setEditorType',
      'setScreenshotsType'
    ]),

    getDataForHistory() {
      const data = JSON.parse(JSON.stringify(this.stagesData))
      return {
        stage: this.stage,
        data
      }
    },

    createEditor() {
      this.blocksEditor = new CreateJsBlocksEditor(this.$refs.canvas)
      this.leftMenuVisible = true

      if (this.containerType) this.blocksEditor.setContainerType(this.containerType)
      Pillar.enabled = this.carcassStrengthening !== null ? !this.carcassStrengthening : true

      if (this.stage > 1) {
        this.$nextTick(() => {
          const toStage = this.stage
          let currentStage

          if (toStage > 1) {
            this.currentStage = toStage - 1
            if (this.$refs.stageSelect) this.$refs.stageSelect.setSelectStage(this.currentStage)
            this.blocksEditor.restoreFromJson(this.stagesData[this.currentStage])

            setTimeout(() => {
              if (this.$refs.stageSelect) this.$refs.stageSelect.setSelectStage(toStage)
            }, 500)
          }
        })
      } else {
        if (this.jsonData) {
          this.blocksEditor.restoreFromJson(this.jsonData)
        } else {
          //this.addHistory(this.getDataForHistory())
        }
      }

      this.blocksEditor.addEventListener(Events.ELEMENTS_CHANGED, this.onElementsChanged)
      this.blocksEditor.addEventListener(Events.ELEMENT_SELECTED, this.onElementSelected)
    },

    onSelectItemInEditor(data) {
      this.needSelectItem = data
      const {type, id} = data
      const itemStage = data.stage

      if (this.currentStage !== itemStage) {
        this.$refs.stageSelect.setSelectStage(itemStage)
      } else {
        this.blocksEditor.selectElementByType(this.needSelectItem)
        this.needSelectItem = {
          type: null,
          id: null
        }
      }
    },

    getItemStage(data) {
      const {type, id} = data
      let itemStage = null

      for (const stage in this.stagesData) {
        const stageData = this.stagesData[stage]

        if (stageData) {
          if (type === BaseEditorElement.ELEMENT_TYPE_WALL_ITEM) {
            stageData.wallItems.forEach((wallItem) => {
              if (wallItem.id === id) itemStage = stage
            })
          } else if (type === BaseEditorElement.ELEMENT_TYPE_BOX_ITEM) {
            stageData.boxItems.forEach((boxItem) => {
              if (boxItem.id === id) itemStage = stage
            })
          } else if (type === BaseEditorElement.ELEMENT_TYPE_EXTERNAL_ITEM) {
            stageData.externalItems.forEach((externalItem) => {
              if (externalItem.id === id) itemStage = stage
            })
          } else if (type === BaseEditorElement.ELEMENT_TYPE_WALL) {
            stageData.walls.forEach((wall) => {
              if (wall.id === id) itemStage = stage
            })
          }
        }
      }

      return itemStage * 1
    },

    createStageImages(type) {
      this.setScreenshotsType(type)

      this.orderSavedStage = this.currentStage
      this.orderStage = 1
      for (let stage = 1; stage <= 3; stage ++) this.setOrderingStageImage({
        stage,
        data: null
      })
      this.createOrderStagesImages(type)
    },

    createOrderStagesImages(type) {
      this.setStage(this.orderStage)
      this.blocksEditor.restoreFromJson(this.jsonData)

      setTimeout(() => {
        this.blocksEditor.getImageData({
          removeBackground: false,
          padding: 200
        }).then(data => {
          this.setOrderingStageImage({
            stage: this.orderStage,
            data
          })

          if (this.orderStage < this.stagesCount) {
            this.orderStage++
            this.createOrderStagesImages(type)
          } else {
            this.orderStage = null
            this.setStage(this.orderSavedStage)

            this.setEditorType('3D')
            // if (type === 'for-ordering') {
            //   this.$router.push('/ordering')
            // }
          }
        })
      }, 100)
    },

    onFullScreenClick() {
      if (document.fullscreenElement) {
        document.exitFullscreen()
      } else {
        document.body.requestFullscreen()
      }
    },

    onZoomIn() {
      this.blocksEditor.zoom(0.5)
    },

    onZoomOut() {
      this.blocksEditor.zoom(-0.5)
    },

    onClearProject() {
      this.setClearProject(false)
      this.blocksEditor.clean()
      this.cleanProject()
      Pillar.StagePillarsList = {}
      Pillar.UpdatePillars()
    },

    onWindowResize() {
      this.updateWindowSize()
    },

    onElementsChanged(e) {
      this.setJsonData(e.detail)
      this.addHistory(this.getDataForHistory())
    },

    onElementSelected(e) {
      const el = e.detail.element
      this.selectedItem = el
    },

    onPrepareImageForDownload() {
      this.blocksEditor.getImageData({
        removeBackground: false,
        padding: 200
      }).then(data => {
        eventBus.$emit(EventBusEvents.ShowDownloadScheme, data)
      })
    },

    addHistory(data) {
      this.historyManager.addHistory(data)
    },

    onRestoreFromHistory(historyData) {
      const historyStage = historyData.stage
      const data = historyData.data

      for (const stage in data) {
        this.setStageJsonData({stage, data: data[stage]})
      }

      if (historyStage !== this.stage) {
        this.setStage(historyStage)
      } else {
        this.blocksEditor.restoreFromJson(data[historyStage])
      }

      this.setJsonData(data[historyStage])
    },

    updateWindowSize() {
      this.windowSize.width = window.innerWidth
      this.windowSize.height = window.innerHeight
      this.$nextTick(() => {
        this.blocksEditor._updateCanvasSize()
      })
    },

    updatePillarsState() {
      Pillar.enabled = !this.carcassStrengthening
      Pillar.UpdatePillars()
    },

    onEditorMenuClicked(data) {
      data = Object.assign({}, data)

      switch (data.type) {
        case 'restoreFromJSON':
          const jsonData = require('@/assets/temp/test.json')
          this.blocksEditor.restoreFromJson(jsonData)
          break

        case 'createJSON':
          break

        case 'box-container':
          this.blocksEditor.createBox()
          break

        case 'box-wall':
          this.blocksEditor.createWall(this.insideWallMaterial)
          break;

        case 'window':
          this.blocksEditor.createWallItem({
            width: data.size ? data.size.width : data.data.raw.width,
            height: 12,
            type: WallItem.Types.Window,
            dictionaryData: data
          })
          break

        case 'door':
          this.blocksEditor.createWallItem({
            width: data.size ? data.size.width : data.data.raw.width,
            height: 14,
            type: WallItem.Types.Door,
            dictionaryData: data
          })
          break

        case 'washing-stand':
          this.blocksEditor.createBoxItem({type: data.editorType, dictionaryData: data})
          break;

        case 'stairs-internal':
          this.blocksEditor.createBoxItem({type: data.editorType, dictionaryData: data})
          break;

        case 'stairs-external':
          this.blocksEditor.createExternalItem(data)
          break;

        case 'additional':
          if (data.data.raw.options) {
            const option = data.data.raw.options[0]
            data.option = {
              key: option.key,
              title: option.title,
              cost: option.price,
              raw: option
            }
          }

          if (data.data.raw.key === 'vytyazhka') {
            this.blocksEditor.createWallItem({width: 10, height: 14, type: WallItem.Types.Additional, dictionaryData: data})
          } else {
            this.blocksEditor.createBoxItem({type: data.editorType, dictionaryData: data})
          }
          break;
      }
    },

    onCanvasMouseMove(e) {
      this.blocksEditor.setMousePosition(e.offsetX, e.offsetY)
    },

    onShowTooltipClick() {
      eventBus.$emit(EventBusEvents.ShowTooltips)
    }
  }
};
</script>
